// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-1qNq9";
var _3 = "wrapper_business-2leop";
var _4 = "header-3CtSO";
var _5 = "segmentInfo-1GJ85";
var _6 = "segmentInfo__item-2eLoz";
var _7 = "planeIcon-HQKo-";
var _8 = "fareFamily-1O6f5";
var _9 = "fareFamily__img-1L_Hi";
var _a = "footer-1_CAL";
var _b = "flightInfo-1n8T1";
var _c = "flightInfo__item-BBMKD";
export { _1 as "__esModule", _2 as "wrapper", _3 as "wrapper_business", _4 as "header", _5 as "segmentInfo", _6 as "segmentInfo__item", _7 as "planeIcon", _8 as "fareFamily", _9 as "fareFamily__img", _a as "footer", _b as "flightInfo", _c as "flightInfo__item" }
export default { "__esModule": _1, "wrapper": _2, "wrapper_business": _3, "header": _4, "segmentInfo": _5, "segmentInfo__item": _6, "planeIcon": _7, "fareFamily": _8, "fareFamily__img": _9, "footer": _a, "flightInfo": _b, "flightInfo__item": _c }
